import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';
import * as Sentry from '@sentry/react';

// material-ui
import { Grid, Typography } from '@mui/material';

import SeverityBasedAlertCard, { type CtaProps } from 'components/cards/SeverityBasedAlertCard';

import useAuth from 'hooks/useAuth';
import usePermissionsAlert from 'features/permissions/hooks/usePermissionsAlert';

import { ADD_PAYMENT_PATH, PRICING_PATH } from 'constants/routeConstants';

// ==============================|| SUBSCRIPTION ALERT ||============================== //

export default function SubscriptionAlert() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { userRole } = useAuth();

  const { merchant, tiktokPlan, youtubePlan } = usePermissionsAlert();

  const handleSubscribeClick = () => {
    Promise.resolve(navigate(PRICING_PATH)).catch((e) => Sentry.captureException(e));
  };

  function displayAlert() {
    const isNotAddPaymentPage = pathname !== ADD_PAYMENT_PATH;
    const isNotPricingPage = pathname !== PRICING_PATH;
    return merchantIsNotSubscribed() && isNotAddPaymentPage && isNotPricingPage;
  }

  function merchantIsNotSubscribed() {
    const notSubscribed = !tiktokPlan && !youtubePlan;
    const merchantIsCustomMerchant = merchant?.hidePlans === true;

    return notSubscribed && !merchantIsCustomMerchant;
  }

  if (!displayAlert()) return null;

  const subscribeCta: CtaProps = userRole === 'ADMIN' ? { buttonCta: 'subscribe-now', buttonOnClick: handleSubscribeClick } : {};

  return (
    <SeverityBasedAlertCard title="activate-your-features" severity="info" {...subscribeCta}>
      <Grid container alignItems="center" aria-label="Subscribe to a plan alert">
        <RenderMessage />
      </Grid>
    </SeverityBasedAlertCard>
  );
}

function RenderMessage() {
  const { formatMessage } = useIntl();
  const { userRole } = useAuth();

  const values = () => {
    if (userRole === 'ADMIN') return `(${formatMessage({ id: 'free-trial-available' })})`;
    return `(${formatMessage({ id: 'contact-your-admin' })})`;
  };

  return (
    <Typography variant="subtitle2">
      <FormattedMessage id="you-need-to-subscribe" values={{ message: values() }} />
    </Typography>
  );
}
